import React, { useEffect, useRef } from 'react'

type VariationPlacement =
  | 'top-left'
  | 'top'
  | 'top-right'
  | 'left'
  | 'auto'
  | 'right'
  | 'bottom-left'
  | 'bottom'
  | 'bottom-right'

const getPlacement = (placement: VariationPlacement): string => {
  switch (placement) {
    case 'top-left':
      return 'mb-auto me-auto'
    case 'top':
      return 'mb-auto mx-auto'
    case 'top-right':
      return 'mb-auto ms-auto'
    case 'left':
      return 'my-auto me-auto'
    case 'right':
      return 'my-auto ms-auto'
    case 'bottom-left':
      return 'mt-auto me-auto'
    case 'bottom':
      return 'mt-auto mx-auto'
    case 'bottom-right':
      return 'mt-auto ms-auto'
    case 'auto':
    default:
      return 'm-auto'
  }
}

interface IProps {
  open: boolean
  blur?: string
  placement?: VariationPlacement
  onOpenChange?(open: boolean): void
}

export const Modal = ({
  open,
  blur,
  placement = 'auto',
  onOpenChange: handleOpenChange,
  children,
}: React.PropsWithChildren<IProps>) => {
  const ref = useRef<HTMLDivElement>(null)
  // Close the modal when ESC is pressed
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        handleOpenChange?.(false)
      }
    }

    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [handleOpenChange])

  if (!open) return null
  return (
    <>
      <div
        className="modal fade fade-in show d-flex"
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          if (!ref?.current?.contains(e.target as HTMLDivElement)) {
            handleOpenChange?.(false)
          }
        }}
      >
        <div
          ref={ref}
          className={`modal-dialog slide-in-blurred-top col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 ${getPlacement(
            placement,
          )}`.trim()}
          style={{ maxWidth: 'unset' }}
        >
          <div className="modal-content border-0 bg-transparent">{children}</div>
        </div>
      </div>
      <div
        className="modal-backdrop fade show"
        style={{ backdropFilter: `blur(${blur})` }}
        onClick={() => handleOpenChange?.(false)}
      />
    </>
  )
}
